import { Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { SpFileManagerComponentModule } from '@components/sp-file-manager';
import { SpSwitchComponent } from '@ui/sp-switch';
import { SpControlHandleComponent } from '@ui/sp-control-handle';

import { WebBackgroundImageSettingsComponent } from './web-background-image-settings.component';

import { SpColorPickerModule } from '@components/sp-color-picker/src/sp-color-picker.module';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        SpSwitchComponent,
        SpControlHandleComponent,
        SpFileManagerComponentModule,
        SpColorPickerModule,
        TooltipModule,
        BsDropdownModule,
        WebBackgroundImageSettingsComponent,
    ],
    exports: [WebBackgroundImageSettingsComponent],
})
export class WebBackgroundImageSettingsModule {}
